"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhoCanApplyForHearingAidSubsidies() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="誰可以申請助聽器補助" className="bg-background py-24 border-b border-border">
            <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
                    {}
                    <div className="lg:col-span-6">
                        <h2 className="text-3xl md:text-4xl lg:text-[40px] font-bold text-primary tracking-tight leading-tight">
                            誰可以申請助聽器補助？
                        </h2>
                    </div>

                    {}
                    <div className="lg:col-span-6">
                        <p className="text-[17px] leading-[1.8] text-foreground/85 m-0">
                            申請助聽器補助的首要條件，是申請人必須依法取得<strong className="text-foreground font-semibold">「身心障礙證明」</strong>，且其障礙類別必須明確標註包含「聽覺機能障礙」。若您或您的家人尚未取得該項證明，請先至戶籍所在地的鄉鎮市區公所社會課（或相關社政單位）領取申請表，並至各縣市政府指定之醫療機構完成專業的聽力鑑定。待鑑定通過並正式取得身心障礙證明後，方能依據個人的福利身分（如一般戶、中低收入戶、低收入戶等），向相關單位提出相對應額度的助聽器購置補助申請。
                        </p>
                    </div>
                </div>
            </div>
        </section>;
}